import React from "react";
import { OrderContainer } from "./style";
import { getOrders } from "api/product";
import Loading from "components/loading";
import EmptyState from "components/emptyState";
import NumberFormat from "components/numberFormat";
import { IoCheckmarkSharp } from "react-icons/io5";

const OrdersPage = () => {
  const [orders, setOrders] = React.useState(null);
  React.useLayoutEffect(() => {
    if (orders === null)
      getOrders()
        .then((res) => {
          console.log(res.data);
          setOrders(res.data.orders);
        })
        .catch((err) => {});
  }, [orders]);
  const dateShow = (date) => {
    const event = new Date(date);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return event.toLocaleDateString("fa-IR", options);
  };
  if (orders === null) {
    return <Loading />;
  }
  return (
    <OrderContainer>
      {orders.length > 0 ? (
        orders.map((order, index) => (
          <div className="order" key={index}>
            <div className="title-area">
              <div className="order-title">{order.title}</div>
              <div className="order-date">{dateShow(order.date)}</div>
            </div>

            <div className="steps">
              <div className="line" />
              {order.steps.map((step, index) => (
                <div
                  className={`step ${step.active ? "active" : ""}`}
                  key={index}
                >
                  {step.active ? (
                    <span>
                      <IoCheckmarkSharp />
                    </span>
                  ) : (
                    ""
                  )}
                  {step.title}
                </div>
              ))}
            </div>
            <div className="bottom-area">
              <div className="invoice-status">
                <div className="order-amount">
                  {NumberFormat({ value: order.amount })}
                </div>
                <div className="order-status">{order.status}</div>
              </div>
              <div className="order-actions">
                <a href={order?.link.url}>{order?.link.title}</a>
              </div>
            </div>
            
          </div>
        ))
      ) : (
        <EmptyState message="سفارش ثبت شده‌ای وجود ندارد" />
      )}
    </OrderContainer>
  );
};
export default OrdersPage;
